import type { IPlace } from "@bbj-types/address";
import type { IContact } from "@bbj-types/contact";
import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import type { UserPartnerAccess } from "@root/utils/enums/structurePartner";
import { useCallback } from "react";
import { axiosStructurePartner, axiosStructurePartnerInstance } from "./axios";

export type TGetStructurePartnerContactsResponse = (Omit<IContact, "author" | "user" | "organisation" | "place"> & {
  author?: { firstName: string; lastName: string };
  userAccess: UserPartnerAccess.LIMITED | UserPartnerAccess.COMPLETE | UserPartnerAccess.NO_ACCESS;
  followUpCount: number;
  place?: IPlace;
  otherStructurePartners?: string[];
})[];

export const useGetStructurePartnerContacts = () => {
  const [state, execute, cancel] = axiosStructurePartner<TGetStructurePartnerContactsResponse, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (structurePartnerId: ObjectId) => {
      return execute({
        url: `${structurePartnerId}/contacts`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetStructurePartnerContactsSuspense = (structurePartnerId: ObjectId) => {
  return useSuspense(
    () => axiosStructurePartnerInstance.get<TGetStructurePartnerContactsResponse>(`${structurePartnerId}/contacts`),
    [structurePartnerId]
  );
};
